import React, { useRef, useEffect, useState, useMemo } from "react";
import { Platform, TouchableOpacity, View } from "react-native";
import { Icon } from "../../../Icon/Icon";
import { Text } from "../../../Text/Text";
import { styles } from "./InputCheckbox.styles";
export const InputCheckbox = ({ onChange, onBlur, name, label, labelFontSize, error, success = false, disabled = false, value = false, inverted = false, labelPosition = "right", styles: userStyles, }) => {
    const isFirstRender = useRef(true);
    const [isSelected, setSelected] = useState(value);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
        }
        else {
            onChange?.(isSelected);
        }
    }, [isSelected]);
    const Wrapper = useMemo(() => ({ children }) => {
        const handlePress = () => {
            if (!disabled) {
                setSelected(!isSelected);
                onBlur?.();
            }
        };
        if (Platform.OS === "web") {
            return (React.createElement("label", { style: {
                    cursor: disabled ? "not-allowed" : "pointer",
                } },
                React.createElement("input", { style: { display: "none" }, type: "checkbox", name: name, value: isSelected.toString(), onClick: handlePress }),
                children));
        }
        if (disabled) {
            React.createElement(View, null, children);
        }
        return (React.createElement(TouchableOpacity, { onPress: handlePress }, children));
    }, [isSelected, disabled]);
    return (React.createElement(Wrapper, null,
        React.createElement(View, { style: labelPosition === "top" ? styles.containerTop : styles.containerRight },
            React.createElement(View, { testID: "checkboxContainer", style: [
                    styles.checkboxContainer,
                    inverted && styles.checkboxContainerInverted,
                    !!error && styles.checkboxContainerError,
                    success && styles.checkboxContainerSuccess,
                    isSelected &&
                        (inverted
                            ? styles.checkboxContainerSelectedInverted
                            : styles.checkboxContainerSelected),
                    disabled && styles.checkboxContainerDisabled,
                    userStyles,
                ] },
                React.createElement(View, { style: [
                        styles.checkbox,
                        inverted && styles.checkboxInverted,
                        isSelected &&
                            (inverted
                                ? styles.checkboxHighlightInverted
                                : styles.checkboxHighlight),
                    ] }, isSelected && (React.createElement(Icon.Checkbox, { color: inverted ? "brand" : "light", width: 16, height: 16 })))),
            typeof label === "string" ? (React.createElement(Text, { fontSize: labelFontSize, styles: [
                    labelPosition === "right" && styles.labelRight,
                    inverted && styles.labelInverted,
                ] }, label)) : (label))));
};
//# sourceMappingURL=InputCheckbox.js.map